import React, { useEffect, useState } from 'react'
import {
  FormModal,
  Tab,
  Button,
  FormModalActions,
  ConfirmModal,
} from 'sputnik-ui'
import { useHistory } from 'react-router-dom'
import { Tabs, Box, Select, MenuItem, FormHelperText } from '@material-ui/core'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { useDispatch } from 'react-redux'
import { addThirdPartyIntercom } from 'features/Intercoms/intercomsSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import { fetchAvailable } from 'features/Devices/installationsSlice'
import { copyToClipboard } from 'utils/helpers'
import { showInfoMessage } from 'store/ui/actions'
import { useTranslation } from 'react-i18next'
import InputWithError from 'components/atoms/InputWithError'
import RtspLinkExplain from 'components/atoms/RtspLinkExplain'
import AddThirdPartyIntercom from 'features/AddThirdPartyIntercom'
import AddThirdPartyCameras from 'features/AddThirdPartyCameras'
import { NavigationPanel } from 'shared/ui'

export default function AddThirdPartyDevice({ open, handleClose, ...props }) {
  const { t } = useTranslation(['devices'])
  const [confirmModal, setConfirm] = useState(false)
  const dispatch = useDispatch()
  const history = useHistory()
  const [createdDevice, setCreatedDevice] = useState({ hex: '', kind: '' })

  const handleSubmitConfirm = () => {
    setConfirm(false)
    copyToClipboard(createdDevice.hex)
    sessionStorage.setItem('third_party_deviceID', createdDevice.hex)
    history.push('/add_address')
  }

  const handleCloseConfirm = () => {
    setConfirm(false)
    handleClose()
  }

  const onSuccess = (hex, kind) => {
    setConfirm(true)
    setCreatedDevice({ hex, kind })
  }

  const tabs = [
    {
      label: t('devices:types.intercom'),
      value: 'intercom',
    },
    {
      label: t('devices:types.camera'),
      value: 'camera',
    },
  ]

  const [currentTab, setCurrentTab] = useState('intercom')
  // Ключи локали лежат в разделах во множественном числе (intercoms / cameras),
  // а вкладки названы в единственном — раньше заголовок показывал сырой ключ.
  const localeSection = currentTab === 'camera' ? 'cameras' : 'intercoms'

  return (
    <>
      <ConfirmModal
        open={confirmModal}
        title={t(`devices:${localeSection}.third_party.helper.installation`)}
        label={t('devices:helper_text.new_device', { hex: createdDevice.hex })}
        actions={
          <>
            <Button
              primary
              fullWidth
              variant="v2"
              onClick={handleSubmitConfirm}
            >
              {t('common:button.install')}
            </Button>
            <Button
              fullWidth
              variant="v2"
              tertiary
              onClick={handleCloseConfirm}
              style={{ textTransform: 'capitalize' }}
            >
              {t('common:button.later')}
            </Button>
          </>
        }
      />
      <FormModal open={open} onClose={handleClose} {...props}>
        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 30 }}>
          <Tabs onChange={(e, tab) => setCurrentTab(tab)} value={currentTab}>
            {tabs.map((tab) => (
              <Tab
                disableRipple
                style={{ marginRight: '1rem' }}
                label={tab.label}
                value={tab.value}
                key={tab.value}
              />
            ))}
          </Tabs>
        </Box>

        <div>
          {currentTab === 'intercom' && (
            <AddThirdPartyIntercom
              onSuccess={(hex) => {
                onSuccess(hex, 'intercom')
              }}
            />
          )}
          {currentTab === 'camera' && (
            <AddThirdPartyCameras
              onSuccess={(hex) => {
                onSuccess(hex, 'camera')
              }}
            />
          )}
        </div>
        <FormModalActions>
          <Button fullWidth variant="v2" tertiary onClick={handleClose}>
            {t('common:button.back')}
          </Button>
        </FormModalActions>
      </FormModal>
    </>
  )
}
